import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { addItem } from '../../actions/CartActions';
import { showModal } from '../../actions/ModalActions';
import RegistryGrid from './RegistryGrid';
import RegistryList from './RegistryList';

class RegistryProducts extends Component {

  constructor(props) {
    super(props);

    this.addToCart = this.addToCart.bind(this);
    this.handleToggleGridReveal = this.handleToggleGridReveal.bind(this);

    this.state = {
      fullGrid: !window.optimizelyTeaseRegistryView,
    };
  }

  componentDidMount() {
    this.excludeFromRegistryTease();
  }

  addToCart(collectionItem, quantity) {
    const { onAddToCart, onCart } = this.props;
    const isGroupGift = collectionItem.contributions.group_gift;

    let addToCartRequest;
    if (isGroupGift) {
      addToCartRequest = {
        skuId: collectionItem.sku_object_id,
        collectionItemId: collectionItem.object_id,
        contribution: quantity,
        itemOrigin: 'WEDDINGS'
      };
    } else {
      addToCartRequest = {
        skuId: collectionItem.sku_object_id,
        collectionItemId: collectionItem.object_id,
        quantity,
        itemOrigin: 'WEDDINGS'
      };
    }

    return onAddToCart(addToCartRequest).then(onCart);
  }

  handleToggleGridReveal() {
    this.setState(prevState => ({
      fullGrid: !prevState.fullGrid
    }));
  }

  excludeFromRegistryTease() {
    // prevent registries with custom collections from seeing this feature
    const { enableCustomCollections, registryCollections } = this.props;
    if (enableCustomCollections && registryCollections.otherCollections && registryCollections.otherCollections.length > 0) {
      this.setState({ fullGrid: true });
    }
  }

  render() {
    const { registryCollections, onShowProduct, view, enableCustomCollections, optimizelyTeaseRegistryView } = this.props;

    return (
      <div>
        {view === 'grid' ?
          <div>
            <RegistryGrid
              collectionItems={registryCollections.defaultCollection}
              collection={_.find(registryCollections.collectionList, collection => collection.object_id === registryCollections.selectedCollectionObjectId)}
              handleToggleGridReveal={this.handleToggleGridReveal}
              onAddToCart={this.addToCart}
              onShowProduct={onShowProduct}
              enableCustomCollections={enableCustomCollections}
              optimizelyTeaseRegistryView={optimizelyTeaseRegistryView}
              showFullGrid={this.state.fullGrid}
            />
            {registryCollections.otherCollections.length > 0 && registryCollections.otherCollections.map(registryCollection => (
              <RegistryGrid
                key={registryCollection.object_id}
                collection={registryCollection}
                collectionItems={registryCollection.registry_collection_items}
                handleToggleGridReveal={this.handleToggleGridReveal}
                onAddToCart={this.addToCart}
                onShowProduct={onShowProduct}
                enableCustomCollections={enableCustomCollections}
                optimizelyTeaseRegistryView={optimizelyTeaseRegistryView}
                showFullGrid={this.state.fullGrid}
              />
            ))}
          </div>
          :
          <div>
            <RegistryList
              collectionItems={registryCollections.defaultCollection}
              onAddToCart={this.addToCart}
              onShowProduct={onShowProduct}
            />
            {registryCollections.otherCollections.length > 0 && registryCollections.otherCollections.map(registryCollection => (
              <RegistryList
                key={registryCollection.object_id}
                collection={registryCollection}
                collectionItems={registryCollection.registry_collection_items}
                onAddToCart={this.addToCart}
                onShowProduct={onShowProduct}
              />
            ))}
          </div>
        }
      </div>
    );
  }
}

RegistryProducts.propTypes = {
  view: PropTypes.string,
  registryCollections: PropTypes.shape({}),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  onCart: PropTypes.func.isRequired,
  enableCustomCollections: PropTypes.bool,
  optimizelyTeaseRegistryView: PropTypes.bool
};

const mapStateToProps = state => (
  {
    registryCollections: state.registryCollections,
  }
);

const mapDispatchToProps = dispatch => (
  {
    onAddToCart: addToCartRequest => dispatch(addItem(addToCartRequest)),
    onShowProduct: collectionItem => dispatch(showModal('REGISTRY_ITEM', { collectionItem }, { size: 'xl' })),
    onCart: () => dispatch(showModal('CART_MODAL'))
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistryProducts);



// WEBPACK FOOTER //
// ./src/components/registry/RegistryProducts.jsx